import TweenMax from 'TweenMax';
/**
 *
 * Hero Fader
 *
 */

( function ( $ ) {
	'use strict';

	var $heroImage    = $( '.hero__image' );
	var $images       = $.makeArray( $heroImage );

	/**
	 * Creates array of hero images
	 */
	function crossfade() {
		TweenMax.to( $images[0], 1.75, { autoAlpha: 0 } );
		TweenMax.to( $images[1], 1.75, { autoAlpha: 1 } );
		$images.push( $images.shift() );
	}

	if( 1 < $heroImage.length ) {

		TweenMax.set( $heroImage, { autoAlpha: 0 } );
		TweenMax.set( $images[0], { autoAlpha: 1 } );

		setInterval( crossfade, 5000 );

	}

} )( jQuery );

( function( $ ) {

	// add body class if IE11
	var isIE11 = /Trident.*rv[ :]*11\./.test( navigator.userAgent );
	if( isIE11 ) {
		$( 'body' ).addClass( 'is-ie11' );
	} else {
		$( 'body' ).removeClass( 'is-ie11' );
	}

	// adjust svg vs img for animated hero
	if( 0 < $( '.header-hero__icon svg' ).length ) {
		$( '.header-hero__icon' ).addClass( 'header-hero__icon--svg' );
	} else {
		$( '.header-hero__icon' ).removeClass( 'header-hero__icon--svg' );
	}

} )( jQuery );
